import { XML_AddPair } from "./XML_AddPair";
import { XML_ShiftRect } from "./XML_ShiftRect";
import { XML_Cmd } from "./XML_Cmd";

export function XML_AddClipRect(clipRect, drawElement, layer) {
  var s = drawElement.GetStream();
  //XML_SetLineWidth(0, drawElement);

  drawElement.OutputElementHead(s, "ph");
  XML_ShiftRect(clipRect, drawElement, layer);
  var top = drawElement.ConvertY(clipRect.fBottom);
  var width = clipRect.fRight - clipRect.fLeft;
  var height = clipRect.fBottom - clipRect.fTop;
  XML_AddPair(clipRect.fLeft, top, "mt", drawElement);
  XML_AddPair(width, 0, "rt", drawElement);
  XML_AddPair(0, height, "rt", drawElement);
  XML_AddPair(-width, 0, "rt", drawElement);
  XML_AddPair(0, -height, "rt", drawElement);
  drawElement.OutputElementTail(s, "ph");
  XML_Cmd("clp", drawElement);
}
